import {Expired, MissingKeyAlias} from "components/src/api/admin/generated";
import {SearchField} from "components/src/certificate/SearchField";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {Utils} from "components/src/utils/Utils";
import {Dispatch, SetStateAction} from "react";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

interface CertificateFilterProps {
    expired? : Expired
    setExpired?: Dispatch<SetStateAction<Expired>>
    missingKeyAlias? : MissingKeyAlias
    setMissingKeyAlias? : Dispatch<SetStateAction<MissingKeyAlias>>
    searchField? : SearchField
    setSearchField : Dispatch<SetStateAction<SearchField>>
    searchValue? : string
    setSearchValue? : Dispatch<SetStateAction<string | undefined>>
    activeSearchValue? : string
    setActiveSearchValue? : Dispatch<SetStateAction<string | undefined>>
}

export const CertificateFilter = ({expired, setExpired, missingKeyAlias, setMissingKeyAlias, searchField,
                                   setSearchField, searchValue, setSearchValue, activeSearchValue, setActiveSearchValue} : CertificateFilterProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    return (
        <>
            {setExpired !== undefined &&
            <Col xs="auto">
                <Form.Select
                             aria-label={t("certificate-filter.expired")}
                             value={expired}
                             onChange={(e) => setExpired(Utils.stringToEnum(Expired, e.target.value as Expired))}>
                    <option value="MATCH_ALL">{t("certificate-filter.all")}</option>
                    <option value="MATCH_UNEXPIRED_ONLY">{t("certificate-filter.unexpired")}</option>
                    <option value="MATCH_EXPIRED_ONLY">{t("certificate-filter.expired")}</option>
                </Form.Select>
            </Col>}

            {setMissingKeyAlias !== undefined &&
            <Col xs="auto">
                <Form.Select
                             aria-label={t("certificate-filter.missing-key-alias")}
                             value={missingKeyAlias}
                             onChange={(e) => setMissingKeyAlias(Utils.stringToEnum(MissingKeyAlias, e.target.value as MissingKeyAlias))}>
                    <option value="ALLOWED">{t("certificate-filter.all")}</option>
                    <option value="NOT_ALLOWED">{t("certificate-filter.private-key")}</option>
                </Form.Select>
            </Col>}

            {setSearchValue !== undefined && setActiveSearchValue !== undefined &&
            <Col xs="auto">
                <InputGroup>
                    <Form.Select
                                 aria-label={t("certificate-filter.search-selection")}
                                 value={searchField}
                                 onChange={(e) => setSearchField(Utils.stringToEnum(SearchField, e.target.value as SearchField))}>
                        <option value="Email">{t("certificate-filter.email")}</option>
                        <option value="Subject">{t("certificate-filter.subject")}</option>
                        <option value="Issuer">{t("certificate-filter.issuer")}</option>
                    </Form.Select>
                    <Form.Control size="sm"
                                  aria-label={t("certificate-filter.search-value")}
                                  type="search"
                                  placeholder={t("certificate-filter.search")}
                                  value={searchValue}
                                  onChange={e => setSearchValue(e.target.value)}
                    />
                    <Button
                            variant="primary"
                            onClick={() => setActiveSearchValue(searchValue)}
                            disabled={activeSearchValue === searchValue}>
                        Search
                    </Button>
                </InputGroup>
            </Col>}
        </>
    )
}
